/* eslint no-prototype-builtins: "off" */

'use strict';

const jQuery = require('jquery');

require('jquery-ui/ui/widgets/sortable');

const Mediator = require('./../../../../core/mediator');
const Container = require('./../../../../core/container');
const Translator = require('./../../../../core/translator');
const Loader = require('./../../../../services/loader');
const SyncPromise = require('./../../../../services/syncPromise');
const Uploader = require('./../../../../bundles/content/service/uploader');
const UploadPlugin = require('./../../../../bundles/content/plugin/upload');

const ContentManager = require('./../../../../bundles/content/component/ContentManager');
const ContentRepository = require('./../../../../bundles/content/repository/ContentRepository');
const SaveManager = require('./../../../../bundles/content/component/SaveManager');
const FormBuilder = require('./../../builder');
const formatBytes = require('./../../../../bundles/content/service/formatBytes');

let ElementClass = require('./../../elementClass');

let templateEditContent = require('./template/content_edit_toolbar.hbs');
let dropzoneTpl = require('./template/dropzone.hbs');

FormBuilder.register('imageList', function(config) {
  let self = new ElementClass(config);
  let overEventName = Container.get('isMobile') ? 'touchstart MSPointerDown' : 'mouseover';
  let clickEventName = Container.get('isMobile') ? 'touchstart MSPointerDown' : 'click';
  let maxEntry = config.maxentry || 99;
  let count = 0;
  let $dropzone;
  let $imagesList;

  const onSubmit = function() {
    let $elements = $imagesList.find('.item');
    let elements = [];

    $elements.each(function() {
      let $current = jQuery(this);

      elements.push({
        'uid': $current.attr('data-uid'),
        'type': $current.attr('data-type'),
      });
    });

    config.form.content.addElement(config['target_element'], elements);
  };

  const onRemoveClick = function() {
    jQuery(this).remove();
    manageMaxEntry();
  };

  const onEditClick = function(media) {
    media.preventOverlay = true;
    Mediator.publish('content:plugin:parameter', media);
  };

  const manageMaxEntry = function() {
    $dropzone[($imagesList.children().length - 1) >= maxEntry ? 'addClass' : 'removeClass']('d-none');
  };

  const buildImage = function(media, path) {
    let url = Container.get('getResourceUrl')(path);
    let $item = jQuery(`
            <div data-uid="${media.uid}" data-type="${media.type}" class="item">
                <div class="figure" style="background-image: url('${url}');"></div>
            </div>
        `);

    $item.on(overEventName, function() {
      let $figure = $item.find('.figure');
      let $edit = $figure.find('.cloud-edit-content');

      if (!$edit.length) {
        $edit = jQuery(templateEditContent());
        $figure.append($edit);

        $edit.find('.btn-remove').on(clickEventName, onRemoveClick.bind($item, media));
        $edit.find('.btn-parameter').on(clickEventName, onEditClick.bind($item, media));
      } else {
        $edit.removeClass('d-none');
      }
    });

    $item.insertAfter($dropzone);

    manageMaxEntry();
  };

  const onChange = function(files) {
    count = files.length;
    Loader.start($imagesList);

    for (let key in files) {
      if (files.hasOwnProperty(key)) {
        uploadFile(files[key]);
      }
    }

    Mediator.publish('on:media-list:upload', config);
  };

  const afterUpload = (media, resource) => {
    UploadPlugin.updateFileOfMedia(media, resource).done(() => {
      count--;
      SaveManager.save();
      buildImage(media, resource.path);

      if (count <= 0) {
        Mediator.publish('after:media-list:upload', config);
        Loader.stop($imagesList);
      }
    });
  };

  const uploadFile = function(file) {
    Uploader.imageIsValid(file).done(function() {
      ContentManager.createElement('Basic/Image').done((media) => {
        Uploader.upload(file, {content: media}).done((uploadData) => {
          afterUpload(media, uploadData);
        });
      });
    }).fail(function() {
      Loader.stop($imagesList);
    });
  };

  const buildSyncImage = function(media) {
    return new Promise((resolve) => {
      let imageInfo = media.getElement(media.getProperties('file_element'));
      let image = ContentManager.buildElement({type: imageInfo.type, uid: imageInfo.uid});

      image.getData().done(() => {
        count--;

        buildImage(media, image.getElement('path'));

        if (count <= 0) {
          Loader.stop($imagesList);
        }
        resolve();
      });
    });
  };

  self.createAddImageBtn = function() {
    let maxSize = formatBytes.format(Container.get('$toolbar').data('maxSize'));
    let label = config.label || 'drop_image_file';
    let icon = config.icon || 'icon-new-post';

    $dropzone = jQuery(dropzoneTpl({
      label,
      icon,
      'label_size': Translator.translate('drop_image_size', {'size': maxSize}),
    }));

    $dropzone.on('click', function() {
      UploadPlugin.createMediaPopin({
        isImage: true,
        onChange: (file) => {
          return new Promise((resolve, reject) => {
            onChange([file]);
            resolve();
          });
        },
        onMediaClick: (resource) => {
          return new Promise((resolve, reject) => {
            ContentManager.createElement('Basic/Image').done((media) => {
              afterUpload(media, resource);
              resolve();
            });
          });
        },
      });
    });

    return $dropzone;
  };

  self.render = function() {
    let $wrapper = jQuery('<div class="image-wrapper"></div>');
    let content = config.form.content;
    let elementName = config['target_element'];

    $imagesList = jQuery('<div class="image-list"></div>');

    Loader.start($imagesList);
    content.getData().done(function() {
      let dataElements = content.getElement(elementName);
      let elements = Array.isArray(dataElements) ? dataElements : (null !== dataElements ? [dataElements] : null);

      if (elements) {
        ContentRepository.findByUids(elements.map((element) => element.uid)).done(function(medias) {
          count = medias.length;
          SyncPromise(medias.reverse(), buildSyncImage);
        });
      } else {
        Loader.stop($imagesList);
      }
    });

    if (maxEntry > 1) {
      $imagesList.sortable({'containment': 'parent', 'items': '.item', 'tolerance': 'pointer'});
    }

    config.form.on('submit.parameters', onSubmit);

    $imagesList.prepend(self.createAddImageBtn());
    $wrapper.append($imagesList);

    manageMaxEntry();

    return $wrapper;
  };

  self.getData = function() {
    return null;
  };

  return self;
});
